export const KEY_CODES = {
  ESC: 27,
}

export const IMAGE_TYPE = {
  ARTWORK: 'artwork',
  PHOTO: 'photo'
}